var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkVariantPlus = function SvgLinkVariantPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.879 7.979a.75.75 0 0 1-1.05 1.05 3.6 3.6 0 0 1 0-5.25l2.625-2.7a3.825 3.825 0 0 1 5.325 0 3.825 3.825 0 0 1 0 5.325l-1.125 1.125a4.8 4.8 0 0 0-.3-1.8l.375-.375a2.4 2.4 0 0 0 0-3.225 2.4 2.4 0 0 0-3.225 0l-2.625 2.7a2.175 2.175 0 0 0 0 3.15m9.3 3.45v1.5h-2.25v2.25h-1.5v-2.25h-2.25v-1.5h2.25v-2.25h1.5v2.25m-2.85-3.225a3.6 3.6 0 0 0-1.05-3.375.75.75 0 0 0-1.05 1.05 2.175 2.175 0 0 1 0 3.15l-2.625 2.7a2.4 2.4 0 0 1-3.225 0 2.4 2.4 0 0 1 0-3.225l.375-.3a5.5 5.5 0 0 1-.3-1.875L1.079 7.454a3.825 3.825 0 0 0 0 5.325 3.825 3.825 0 0 0 5.325 0l1.35-1.35a4.5 4.5 0 0 1 2.325-3.225"
  })));
};
export default SvgLinkVariantPlus;